import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import Header from '../../components/Header';
import ExpenseCaptureForm from '../../components/expenses/ExpenseCaptureForm';
import { FIELD_EXPENSES_QUERY_KEY } from './FieldExpensesScreen';

/**
 * The field tree's receipt capture. The form — camera, scan, who paid, the
 * 0389 amount rule, the job and ticket pickers — lives in ExpenseCaptureForm,
 * shared with the office tree since FE-1. In `mode="field"` it renders exactly
 * what this screen rendered before the extraction: no "What was this for?"
 * control, because field receipts are always on a job (D2).
 */
export default function FieldExpenseCaptureScreen() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div className="animate-fade-in min-h-full bg-fieldiq-dark pb-[var(--bottom-chrome)]">
      <div className="max-w-[1920px] mx-auto">
        <Header />
        <div className="px-4 py-3 border-b border-fieldiq-border flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-fieldiq-text" aria-label="Back">
            <ArrowLeft size={26} />
          </button>
          <h1 className="text-xl font-bold text-white">Add Receipt</h1>
        </div>
      </div>

      <ExpenseCaptureForm
        mode="field"
        onFiled={() => {
          queryClient.invalidateQueries({ queryKey: FIELD_EXPENSES_QUERY_KEY });
          navigate('/field/expenses', { replace: true });
        }}
      />
    </div>
  );
}
